import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '@services/navigation.service';

@Component({
  selector: 'app-error-component',
  templateUrl: './error-component.component.html',
  styleUrls: ['./error-component.component.scss'],
  standalone: false,
})
export class ErrorComponentComponent {
  @Input() errorCode!: string;
  @Input() errorTitle!: string;
  @Input() errorDescription!: string;
  @Input() quickTip!: string;

  constructor(
    private navigationService: NavigationService,
    private router: Router,
  ) {}

  public navigateToHome(): void {
    this.navigationService.navigateToSpaces();
  }
}
